import { Dispatch } from '@reduxjs/toolkit';
import { requestHandler } from 'lib/api';

export interface EntityRecord<T> {
  tenantId: string;
  entity: string;
  entityId: number;
  operation: 'CREATE' | 'UPDATE' | 'DELETE';
  after: T;
  timestamp: number;
}

export const getEntityRecord = async (
  dispatch: Dispatch,
  entity: string,
  entityId: number,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/record/${entity}/${entityId}`,
    dispatch,
  });
  if (response) return response.data;
};
